import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import { withRouter } from "react-router";
import { QUERY_SETTING } from "../../service/ApolloClient/ApolloQueries";
import { client } from "../../service/ApolloClient/ApolloClient";
import SettingEdit from "../../components/Setting/Edit/Edit";
import Loading from "../../components/UI/Loading/Loading";

class SettingEditPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      data: null,
      id: props.match.params.id,
    };
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });
    client
      .query({
        query: QUERY_SETTING,
        variables: {
          id: parseInt(this.state.id),
        },
      })
      .then((res) => {
        this.setState({
          data: res.data.setting,
          loading: false,
        });
      })
      .catch((err) => {});
  }

  render() {
    const { loading, data } = this.state;

    return (
      <Wrapper>
        <BreadcrumbsTemp
          items={[
            {
              title: "ویرایش تنظیمات",
              to: "/setting/edit/" + this.state.id,
            },
          ]}
        />

        <Grid container={true}>
          <Grid item xs={12}>
            {loading ? (
              <Loading />
            ) : data ? (
              <SettingEdit data={data} />
            ) : (
              "اطلاعات وجود ندارد"
            )}
          </Grid>
        </Grid>
      </Wrapper>
    );
  }
}

export default withRouter(SettingEditPage);
